import React, { useState } from "react";
import { Table, Tag, Button, Modal, Descriptions, Space, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";

const PumpDetailsTable = ({ data }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedPump, setSelectedPump] = useState(null);

  const showModal = (record) => {
    setSelectedPump(record);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedPump(null);
  };

  const columns = [
    {
      title: "Pump Name",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Pump Maker",
      dataIndex: "pump_maker",
      key: "pump_maker",
    },
    {
      title: "Pump Model",
      dataIndex: "pump_model",
      key: "pump_model",
    },
    {
      title: "Selected Parameters",
      dataIndex: "selected_parameters",
      key: "selected_parameters",
      width: "50%",
      render: (params) =>
        params && params.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {params.map((param, index) => (
              <Tag color="blue" key={index}>
                {param}
              </Tag>
            ))}
          </div>
        ) : (
          <span>—</span>
        ),
    },

    {
      title: "Other Parameters",
      dataIndex: "other_parameters",
      key: "other_parameters",
      width: "20%",
      render: (params) =>
        params && params.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {params.map((item, index) => (
              <Tag color="green" key={index}>
                {item.name} ({item.unit})
              </Tag>
            ))}
          </div>
        ) : (
          <span>—</span>
        ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="View Details">
            <Button
              type="primary"
              icon={<EyeOutlined />}
              onClick={() => showModal(record)}
              size="small"
            >
              View
            </Button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={{ pageSize: 5 }}
        bordered
        className="custom-table"
      />

      <Modal
        title="Pump Details"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={700}
      >
        {selectedPump && (
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Pump Name">{selectedPump.title}</Descriptions.Item>
            <Descriptions.Item label="Maker">{selectedPump.pump_maker}</Descriptions.Item>
            <Descriptions.Item label="Model">{selectedPump.pump_model}</Descriptions.Item>

            <Descriptions.Item label="Selected Parameters">
              {Array.isArray(selectedPump.selected_parameters) &&
              selectedPump.selected_parameters.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {selectedPump.selected_parameters.map((param, index) => (
                    <Tag color="blue" key={index}>
                      {param}
                    </Tag>
                  ))}
                </div>
              ) : (
                "—"
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Other Parameters">
              {Array.isArray(selectedPump.other_parameters) &&
              selectedPump.other_parameters.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {selectedPump.other_parameters.map((item, index) => (
                    <Tag color="green" key={index}>
                      {item.name} ({item.unit})
                    </Tag>
                  ))}
                </div>
              ) : (
                "—"
              )}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </>
  );
};

export default PumpDetailsTable;
